import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalSearchFilter } from './global-search-filter.pipe';

@NgModule({
  declarations: [GlobalSearchFilter],
  exports: [
    GlobalSearchFilter
  ],
  imports: [CommonModule]
})
export class GlobalSearchFilterModule { }
